/**
 * THE VIEW FEED CONTENT TABLE
 *
 * @version  0.1
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { hashHistory } from 'react-router';

import CustomTableBody from './../../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import InfiniteScrollTable from './../../../reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx';
import SortIndicator from './../../../reusable/SortIndicators/SortIndicators.index.jsx';
import CountBox from './../../../reusable/CountBox/CountBox.index';

import Spinnable from '../../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';

import reduxStore from './../../../reduxStore';
import utils from './../../../utils/utilities';
import xhr from './../../../utils/xhr';

import api from './../ViewFeedContent.api';
import commonActions from './../../../api/Common.actions';
import { RSS_FEED_PAGE_SIZE } from './../../../constants';

import {
    PESTLEContentCell,
    DateContentCell,
    LanguageCell,
    TitleCellNoLink
} from './../../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';
import SelectOptionsLanguage from './../../../reusable/Dropdowns/SelectOptionsLanguage.jsx';



class FeedContentTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tableStore: [],
            count: null,
            urlParams: {
                refreshFlag: true,
                sortBy: '_id',
                direction: 'DESC',
                language: reduxStore.getState().user.preferences.articlesLanguageFilter,
                pageSize: RSS_FEED_PAGE_SIZE,
                pageNumber: 0
            }
        };

        this.buildArticleLink = this.buildArticleLink.bind(this);

        this.columnWidths = [42, 13, 12, 13, 10, 8];
        this.rowsModel = [
            {
                fieldId:   'articleId',
                fieldType: TitleCellNoLink,
                props:     {
                    clickHandler: this.buildArticleLink
                }
            },
            {
                fieldId:   'language',
                fieldType: LanguageCell
            },
            {
                fieldId:   'addedToFeedDate',
                fieldType: DateContentCell,
                classes:   'notranslate'
            },
            {
                fieldId:   'entityName',
                fieldType: 'string',
                classes:   'notranslate'
            },
            {
                fieldId:   'subjects',
                fieldType: PESTLEContentCell,
                format:    this.parsePestleResponse,
                classes:    'riskAngle'
            },
            {
                fieldId:   'subjects',
                fieldType: PESTLEContentCell,
                format:    this.parsePestleResponse,
                classes:    'riskLevel'
            }
        ];
        this.unmounted = false;
        this.tableStore = [];

        this.filterByLanguage = this.filterByLanguage.bind(this);
        this.sortByDate = this.sortByDate.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    parsePestleResponse(pestles) {
        let pestleMap = utils.createPestleBulletMap(pestles);

        for (let j = 0; j < pestles.length; j++) {

            let value = pestles[j].risks;

            for (let i = 0; i < value.length; i++) {
                if (value[i].riskPerspective === "company") {
                    pestleMap[value[i].riskFactor][value[i].riskScore] = true;
                    pestleMap[value[i].riskFactor]["visible"] = true;
                }
            }

        }

        return pestleMap;
    }

    filterByLanguage(event) {
        let language = event.target.value;

        this.setState(
            {
                urlParams: Object.assign({}, this.state.urlParams, {language: language})
            },
            this.loadData // Trigger the loadData method after the state updates are completed.
        );

        commonActions.updateUserPrefs({articlesLanguageFilter: language});
    }

    sortByDate() {
        let direction = this.state.urlParams.direction;
        direction = direction === "DESC" ? "ASC" : "DESC";

        this.setState(
            {
                urlParams: Object.assign({}, this.state.urlParams, {sortBy: "_id", direction: direction})
            },
            this.loadData // Trigger the loadData method after the state updates are completed.
        );
    };

    loadData() {
        window.scrollTo(0, 0);
        this.props.spinner.showSpinner();
        let urlParams = this.state.urlParams;
        urlParams.pageNumber = 0;
        this.tableStore = []; // clear this.tableStore when user refreshes the feed
        this.setState({ urlParams, tableStore: [] }, () => {
            api.loadFeedArticlesCount(this.props.feedId, this.state.urlParams).then(response => {
                reduxStore.dispatch({type: 'ARTICLE_PAGE_TOTAL_COUNT', payload: response});
                this.setState({ count: response });
            }).then(() => {
                reduxStore.dispatch({
                    type: 'ARTICLE_PAGE_RESET',
                    payload: {
                        url: "/#/",
                        urlParams: {}
                    }
                });
                this.loadFeedBufferArticles(urlParams);
            }).catch((error)=>{
                this.props.spinner.hideSpinner();
                xhr.handleAllErrors(error);
            });
        });
    }

    loadFeedBufferArticles(urlParams) {
        api.loadFeedArticles(this.props.feedId, this.state.urlParams)
            .then((result) => {
                this.setState({
                    urlParams:  Object.assign(
                        {},
                        this.state.urlParams,
                        {
                            refreshFlag: !this.state.urlParams.refreshFlag,
                            pageNumber:  ++this.state.urlParams.pageNumber
                        }
                    ),
                    tableStore: this.state.tableStore.concat(result)
                });

                if (urlParams.language !== this.state.urlParams.language) {
                    this.loadData(); // language changed in the meantime, reload table
                }

                reduxStore.dispatch({type: 'ARTICLE_PAGE_FILL_DATA', payload: result});

                this.props.spinner.hideSpinner();

                if(this.state.count > result.length) {
                    this.loadFeedArticles(this.state.urlParams);
                }
            })
            .catch((error) => {
                this.props.spinner.hideSpinner();
                xhr.handleAllErrors(error);
            });
    }

    loadFeedArticles(urlParams) {
        this.setState({isTableStoreSpinnerVisible: true});
        api.loadFeedArticles(this.props.feedId, this.state.urlParams)
            .then((result)=>{
                this.setState({
                    urlParams: Object.assign(
                        {},
                        this.state.urlParams,
                        {
                            refreshFlag : !this.state.urlParams.refreshFlag,
                            pageNumber: ++this.state.urlParams.pageNumber
                        }
                    )
                });

                if (urlParams.language !== this.state.urlParams.language) {
                    this.loadData(); // language changed in the meantime, reload table
                } else if (this.state.urlParams.pageSize * this.state.urlParams.pageNumber < this.state.count && !this.unmounted) {
                    this.loadFeedArticles(urlParams);
                }

                for (let i = 0; i < result.length; i++) {
                    this.tableStore.push(result[i])
                }

                reduxStore.dispatch({type: 'ARTICLE_PAGE_FILL_DATA', payload: result});

                //subtract the loadFeedBufferArticles page
                if (this.state.count === this.tableStore.length + RSS_FEED_PAGE_SIZE) {
                    this.setState({
                        urlParams:  Object.assign(
                            {},
                            this.state.urlParams,
                            {
                                refreshFlag: !this.state.urlParams.refreshFlag
                            }
                        ),
                        tableStore: this.tableStore,
                        isTableStoreSpinnerVisible: false
                    });
                }
            })
            .catch((error)=>{
                xhr.handleAllErrors(error);
            });
    }

    buildArticleLink(event, articleId, articleIndex) {
        let location = window.location.href.substr(window.location.href.indexOf('#/') + 2);

        let config = {};
        config.headerKey = "viewFeedContent";
        config.ttl = this.props.feedTitle;
        config.internalStore = false;
        config.backRoute = location;
        config.url = '/api/feeds/' + this.props.feedId + '/articles/paginated';
        config.countUrl = '/api/feeds/' + this.props.feedId + "/articles/count";

        hashHistory.push('/view-article/' + articleId + '/' + articleIndex + "?config=" + encodeURIComponent(JSON.stringify(config)));

        // return '/#/view-article/' + rowData.articleId + '/' + encodeURIComponent(location) + "?ttl=" + title + "&navigateByIndex=true&articleIndex=" + rowData.index + "&headerKey=viewFeedContent";
    }

    render() {
        
        return (
            <InfiniteScrollTable tableId="feedContentTable"
                                 columnWidths={this.columnWidths}
                                 rowsModel={this.rowsModel}>
                <thead className="custom-table-head">
                <tr>
                    <th>

                        <CountBox
                            totalCount={this.state.count}
                            partialCount={this.state.count} />

                        <button className="button-doc-sm refresh-button" onClick={this.loadData}>
                            <FormattedMessage id="RSS_View_UIText_viewRssFeedContent.refreshButton" />
                        </button>

                    </th>
                    <th>
                        <SelectOptionsLanguage language={this.state.urlParams.language}
                                               onChange={this.filterByLanguage} />
                    </th>
                    <th>
                        <button type="button" className="date-button" onClick={this.sortByDate}>
                            <FormattedMessage id="RSS_Feed_UIText_feedListing.date" />
                            <SortIndicator direction={this.state.urlParams.direction.toLowerCase()} />
                        </button>
                    </th>
                    <th><FormattedMessage id="RSS_Feed_UIText_feedListing.entitiesMentioned" /></th>
                    <th><FormattedMessage id="Dashboard_Charts_UIText_dashboard.filters.riskAngle" /></th>
                    <th><FormattedMessage id="Dashboard_Charts_UIText_dashboard.filters.riskLevel" /></th>
                </tr>
                </thead>
                <CustomTableBody ref="feedContentTableBody"
                                 dataStore={this.state.tableStore}
                                 urlParams={this.state.urlParams}
                                 preventScrollToTop
                                 datastoreSpinner={this.state.isTableStoreSpinnerVisible}
                />
            </InfiniteScrollTable>
        );

    }

}

export default Spinnable(FeedContentTable);


// WEBPACK FOOTER //
// ./src/scripts/pages/ViewFeedContent/components/FeedContentTable.jsx